import { io } from 'socket.io-client';
import { API_URL } from '../../../utils/constants';

const SOCKET_EVENT = 'retail_pos:snapshot';

const getSocketUrl = () => {
  const apiBase = String(API_URL || '').trim();
  return apiBase.endsWith('/api') ? apiBase.slice(0, -4) : apiBase;
};

export const connectRetailPosSocket = ({ token, onSnapshot, onConnect, onDisconnect, onError }) => {
  const authToken = String(token || localStorage.getItem('token') || '').trim();
  if (!authToken) return null;

  const socket = io(getSocketUrl(), {
    transports: ['websocket'],
    auth: {
      token: `Bearer ${authToken}`,
    },
    // We reconnect manually on browser "online" events from the store hook.
    // This avoids continuous backend retry traffic while offline.
    reconnection: false,
  });

  socket.on('connect', () => onConnect?.());
  socket.on('disconnect', () => onDisconnect?.());
  socket.on('connect_error', (error) => onError?.(error));
  socket.on(SOCKET_EVENT, (payload) => onSnapshot?.(payload));

  return socket;
};
